import { commonNewClassnames } from '@common';

const prefix = 'admin/reporting';

export const newClassnames = (name) => commonNewClassnames(`${prefix}-${name}`);

export const routerPaths = {
    home: `/${prefix}`,
    staffAcessReview: `/${prefix}/staffAcessReview`,
    applicationUsage: `/${prefix}/applicationUsage`,
    auditlogs: `/${prefix}/auditlogs`,
    suspiciousActivity: `/${prefix}/suspiciousActivity`,
    signInLogs: `/${prefix}/SignInLogs`,
};
